var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66264 0C2.99086 0 0 2.99086 0 6.66264C0 10.3344 2.99086 13.3253 6.66264 13.3253C8.25935 13.3253 9.72572 12.7583 10.8749 11.8171L14.853 15.7951C14.9144 15.8591 14.9879 15.9101 15.0693 15.9453C15.1507 15.9805 15.2382 15.9991 15.3269 16C15.4155 16.0009 15.5035 15.9841 15.5855 15.9506C15.6676 15.9171 15.7422 15.8675 15.8048 15.8048C15.8675 15.7422 15.9171 15.6676 15.9506 15.5855C15.9841 15.5035 16.0009 15.4155 16 15.3269C15.9991 15.2382 15.9805 15.1507 15.9453 15.0693C15.9101 14.9879 15.8591 14.9144 15.7951 14.853L11.8171 10.8749C12.7583 9.72572 13.3253 8.25935 13.3253 6.66264C13.3253 2.99086 10.3344 0 6.66264 0ZM6.66264 1.33253C9.61428 1.33253 11.9928 3.71101 11.9928 6.66264C11.9928 9.61428 9.61428 11.9928 6.66264 11.9928C3.71101 11.9928 1.33253 9.61428 1.33253 6.66264C1.33253 3.71101 3.71101 1.33253 6.66264 1.33253Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.af2bb0632e1e2e087846fe31e01fdc1b.svg";
export { ForwardRef as ReactComponent };